import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import algoliasearch, { SearchClient } from 'algoliasearch/lite';
import { SettingService } from '../../services/setting.service';
import { NgAisConfigureModule } from 'angular-instantsearch';
import { NgAisConfigure } from 'angular-instantsearch/configure/configure';
import { SearchParameters } from 'angular-instantsearch/instantsearch/instantsearch';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-algolia-search',
  templateUrl: './algolia-search.component.html',
  styleUrls: ['./algolia-search.component.scss']
})
export class AlgoliaSearchComponent implements OnInit {
  @Input() bankControl: FormControl = new FormControl();
  @Input() keyword: string = '';

  @Input() propValue: string = 'objectID';
  @Input() propDisplay: string = 'displayName';
  @Input() placeholder: string = 'Search...';
  @Input() placeholderLabel: string = 'Search...';

  @Input() handleClick: (query: string) => void = null;
  @Input() handleClean: () => void = null;
  @Input() handleRefresh: (keyword: string) => void = null;
  @Input() typeSearch: string = 'autocomplete';

  @Input() indexName: string = '';
  @Input() customConfiguration: SearchParameters = null;

  @Output() onQueryEnter = new EventEmitter<string>();

  @ViewChild('aisConfigure') aisConfigure: NgAisConfigure;

  searchClient: SearchClient = null;
  config = null;
  configuration: SearchParameters = {
    filters: '',
    //Attribute searchable
    restrictSearchableAttributes: [
      'displayName', 
      'realName', 
      'private_contactFullname', 
      'private_contactPhone',
      'private_contactEmail', 
      'profileId', 
      'publishedReasons',
      'publishedBios'
    ],
    //Attribute retrivable
    attributesToRetrieve: [
      'automateDataStateId', 'displayName', 'profileId', 'realName', 'media',
      'private_contactFullname', 'private_contactEmail', 'private_contactPhone',
    ],
    attributesToHighlight: [
      'displayName', 
      'realName', 
      'private_contactFullname', 
      'private_contactPhone',
      'private_contactEmail', 
    ],
    page: 0,
    hitsPerPage: 20,
    highlightPreTag: '<span style="color: blue; background-color: #74b9f9;">',
    highlightPostTag: '\</span>'
  }

  constructor(private settingService: SettingService) {

  }

  ngOnInit(): void { 
    // Apply custom configuration if provided
    if (this.customConfiguration) {
      this.configuration = { ...this.configuration, ...this.customConfiguration };
    }
    
    this.settingSearch();
  }

  async settingSearch() {
    try {
      let resp = await this.settingService.algoliaSetting().toPromise();
      if (resp && resp.result) {
        let settings = resp.result;
        let appId = settings.find(x => x.key == "ALGOLIA_APP_ID")?.value;
        let searchKey = settings.find(x => x.key == "ALGOLIA_SEARCH_API_KEY")?.value;
        let indexName = this.indexName || settings.find(x => x.key == "ALGOLIA_INDEX_NAME")?.value;

        if (appId && searchKey)
          this.searchClient = algoliasearch(appId, searchKey);

        if (indexName && this.searchClient)
          this.config = { indexName: indexName, searchClient: this.searchClient, };
      }
    }
    catch (ex) {
      console.error(ex);
    }
  }

  setValue(query: string) {
    console.log(query);
    if (this.handleClick)
      this.handleClick(query);
  }

  public searchParameters = {
    query: ''
  };

  public setQuery({ query }: { query: string }) {
    this.searchParameters.query = query;
  }

  public clickClean() {
    if (this.handleClean) {
      this.handleClean();
    }
  }

  public clickRefresh() {
    if (this.handleRefresh) {
      this.handleRefresh(this.keyword);
    }
  }
}

